"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { isNavGroupActive } from "@/lib/nav-data";
import { useNavGroups } from "./NavHubsContext";

const itemClass =
  "text-label text-black hover:bg-sand-10 rounded-xl px-3 py-2 transition-colors whitespace-nowrap";

const DesktopNav = () => {
  const pathname = usePathname();
  const groups = useNavGroups();

  return (
    <nav className="flex items-center gap-8">
      {groups.map((group) => (
        <div key={group.key} className="relative group">
          <Link
            href={group.href}
            className={cn(
              "text-label text-gray-100 hover:opacity-70 transition-opacity py-2 block",
              {
                "font-bold": isNavGroupActive(group, pathname, groups),
              }
            )}
          >
            {group.label}
          </Link>

          {group.subItems.length > 0 && (
            <div
              className="absolute top-full left-0 pt-2 opacity-0 pointer-events-none
                         group-hover:opacity-100 group-hover:pointer-events-auto
                         group-focus-within:opacity-100 group-focus-within:pointer-events-auto
                         transition-opacity duration-150"
            >
              <div className="bg-white rounded-2xl p-3 shadow-lg flex flex-col gap-2 min-w-[180px]">
                {group.subItems.map((item) =>
                  item.children ? (
                    // Dritte Ebene: klappt seitlich auf, per Hover oder
                    // Tastatur-Fokus (focus-within) — die zweite Ebene oben
                    // reagiert dafuer ebenfalls auf focus-within. Neue Abstaende
                    // per Rand statt `gap` (iOS 14).
                    <div key={item.href} className="relative group/sub">
                      <button
                        type="button"
                        aria-haspopup="true"
                        className={cn(itemClass, "w-full flex items-center justify-between cursor-default [&>*+*]:ml-4")}
                      >
                        <span>{item.label}</span>
                        <ChevronRight className="size-4 shrink-0" />
                      </button>
                      <div
                        className="absolute left-full top-0 pl-5 opacity-0 pointer-events-none
                                   group-hover/sub:opacity-100 group-hover/sub:pointer-events-auto
                                   group-focus-within/sub:opacity-100 group-focus-within/sub:pointer-events-auto
                                   transition-opacity duration-150"
                      >
                        <div className="bg-white rounded-2xl p-3 shadow-lg flex flex-col [&>*+*]:mt-2 min-w-[180px]">
                          {item.children.map((child) => (
                            <Link
                              key={child.href}
                              href={child.href}
                              className={cn(itemClass, { "font-bold": pathname === child.href })}
                            >
                              {child.label}
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <Link key={item.href} href={item.href} className={itemClass}>
                      {item.label}
                    </Link>
                  )
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </nav>
  );
};

export { DesktopNav };
